export const DATA_FETCH_INTERVAL_MILLIS = 20000; // 10s
